// extracted by mini-css-extract-plugin
module.exports = {"container":"ContainerWithScroll-modulecontainer3aj","showTopShadow":"ContainerWithScroll-moduleshowTopShadow3jz","showBottomShadow":"ContainerWithScroll-moduleshowBottomShadow2E4"};